export const CONTACT = {
  phone: "+91 99945 56889",
  phoneRaw: "919994556889",
  address: "Rafeek Construction, Muthu Nagar, Sivaganga - 630561, Tamil Nadu",
  area: "Sivagangai & surrounding districts, Tamil Nadu",
  youtube: "https://www.youtube.com/@Rafeekhomessivaganga",
  logo: "/rafeek-logo.jpg",
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Films", href: "#films" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Built to be lived in",
    body: "Every Rafeek home is designed around the way real families live — light-filled rooms, honest materials, and layouts that grow with you.",
  },
  {
    no: "02",
    title: "Turnkey, transparent",
    body: "From the first drawing to the final key, one team handles everything. No hidden costs, no surprises — just a home delivered on time.",
  },
  {
    no: "03",
    title: "Rooted in Sivagangai",
    body: "We build where we belong. Deep local knowledge of land, climate and craft means homes that last generations in Tamil Nadu.",
  },
  {
    no: "04",
    title: "Finished with feeling",
    body: "Interior design isn't an afterthought. We finish every villa with the warmth, detail and quality you'd expect from a home you'll love.",
  },
];

export const SERVICES = [
  {
    tag: "01 / Construction",
    title: "Turnkey Home Construction",
    body: "Full-service residential construction — foundation to finish. Structurally sound, beautifully built individual homes.",
    img: "https://images.pexels.com/photos/1078879/pexels-photo-1078879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "02 / Homes for Sale",
    title: "Ready-to-Move Homes",
    body: "Move-in ready 2BHK & 3BHK homes across Sivagangai, priced from ₹40 lakhs. Book before launch and save.",
    img: "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjIxMDU1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "03 / Villas",
    title: "Luxury Individual Villas",
    body: "Spacious duplex villas up to ₹85 lakhs — premium fittings, private plots and modern architecture built for you.",
    img: "https://images.unsplash.com/photo-1660361338517-8c8fbb3ac264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjIxMDU1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "04 / Interiors",
    title: "Interior Design & Finish",
    body: "Complete interior design — modular kitchens, wardrobes, false ceilings and finishes that make a house a home.",
    img: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg2MjEwNTUzfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const PROJECTS = [
  {
    title: "Duplex 3BHK — Sivaganga",
    meta: "Luxury Duplex · ₹80 Lakhs",
    img: "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjIxMDU1M3ww&ixlib=rb-4.1.0&q=85",
    span: "lg",
  },
  {
    title: "Muthu Nagar Villa",
    meta: "3BHK · ₹42 Lakhs",
    img: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjIxMDU1M3ww&ixlib=rb-4.1.0&q=85",
    span: "sm",
  },
  {
    title: "Modern Living Interior",
    meta: "Interior Design",
    img: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg2MjEwNTUzfDA&ixlib=rb-4.1.0&q=85",
    span: "sm",
  },
  {
    title: "1150 sq.ft Home",
    meta: "2BHK · ₹46 Lakhs",
    img: "https://images.unsplash.com/photo-1660361338517-8c8fbb3ac264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjIxMDU1M3ww&ixlib=rb-4.1.0&q=85",
    span: "lg",
  },
];

// Real videos from the Rafeek Homes YouTube channel
export const VIDEOS = [
  { id: "HfKkimzOzJ4", title: "₹80 Lakh Duplex — Luxurious 3BHK Home Tour", views: "1.4K views" },
  { id: "2TAH-p5-ZTo", title: "New House Launch — ₹42 Lakhs, Muthu Nagar", views: "6.2K views" },
  { id: "QwDr-K68qlk", title: "1150 sq.ft House — ₹46 Lakhs, Sivaganga", views: "7.7K views" },
  { id: "QMIi43affkk", title: "68 Lakh Home — Rafeek Construction", views: "717 views" },
  { id: "ZD3UyQ21Mic", title: "2BHK 1125 sq.ft — Luxurious Finish", views: "1.8K views" },
  { id: "zGS5aS0_EZE", title: "New Launch 1000 sq.ft — ₹40 Lakhs", views: "2.3K views" },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Homes Delivered" },
  { value: 12, suffix: "yrs", label: "Building Since" },
  { value: 200, suffix: "K+", label: "Sq.ft Constructed" },
  { value: 100, suffix: "%", label: "On-Time Handover" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Rafeek Homes handed over our villa exactly as promised. The finish quality is far beyond what we expected for the price.",
    name: "Mohammed Ashiq",
    role: "3BHK Owner, Sivaganga",
  },
  {
    quote:
      "Transparent from day one. We could see the progress on their channel and in person. A genuinely trustworthy builder.",
    name: "Lakshmi Priya",
    role: "2BHK Owner, Muthu Nagar",
  },
  {
    quote:
      "They handled construction and interiors together, so we just walked into a finished home. Highly recommend.",
    name: "Suresh Kumar",
    role: "Villa Owner, Sivagangai",
  },
];
